export const COM_966_TEST_NAME = 'client_update_sign_in_sign_up_com966_test_20221121';
export const COM_966_TEST_PERCENT = 0.5;
